// Small helper exposing the signed-in session's email and a sign-out action.
// The ported ManagerFooter shows the *manager* name resolved from the database
// (people.primary_email), not this. Both are useful: one says who the database
// thinks you are, this says which Google account the browser is holding. When
// they disagree, that is exactly the bug an operator needs to see.
import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export function useSignedInEmail(): string | null {
  const [email, setEmail] = useState<string | null>(null)
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setEmail(data.session?.user.email ?? null))
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) =>
      setEmail(s?.user.email ?? null),
    )
    return () => sub.subscription.unsubscribe()
  }, [])
  return email
}

export async function signOut(): Promise<void> {
  await supabase.auth.signOut()
}
